var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.326,
    height: 18.326,
    viewBox: "0 0 18.326 18.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M10.119,2A8.119,8.119,0,1,1,2,10.119,8.122,8.122,0,0,1,10.119,2Zm0,14.435A6.315,6.315,0,1,0,3.8,10.119,6.314,6.314,0,0,0,10.119,16.435Zm7.655.064,2.552,2.551L19.05,20.326,16.5,17.774,17.774,16.5Z",
    transform: "translate(-2 -2)",
    fill: "#dcb209"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e41e998219aa14442d97b1058b2d4e11.svg";
export { ForwardRef as ReactComponent };